module.exports = __webpack_public_path__ + "img/home.425299ea.svg";